import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const rdBlocksApi = {
  getDistricts: () =>
    api.get<ApiResponse<{id: number, name: string}[]>>('/locations/districts'),
  
  getRdBlocks: (districtId?: number) =>
    api.get<ApiResponse<{id: number, name: string, district_id: number}[]>>(
      districtId ? `/locations/rd-blocks/${districtId}` : '/locations/rd-blocks'
    ),

  getAllRdBlocks: () =>
    api.get<ApiResponse<{id: number, name: string, district_id: number, is_active: boolean}[]>>('/locations/rd-blocks/all'),

  getActiveRdBlocks: () =>
    api.get<ApiResponse<{id: number, name: string, district_id: number, is_active: boolean}[]>>('/locations/rd-blocks/active'),

  createRdBlock: (data: { name: string, district_id: number, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/locations/rd-blocks', data),

  updateRdBlock: (id: number, data: { name: string, district_id: number, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/locations/rd-blocks/${id}`, data),

  deleteRdBlock: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/rd-blocks/${id}`),

  hardDeleteRdBlock: (id: number) =>
    api.delete<ApiResponse<any>>(`/locations/rd-blocks/${id}/permanent`),
}

